import type { PolygonOpenContour } from '../polygon-open-contour';
import type { PointArray } from '../types/contour-definition-array-type';

import { getPointPointDistance } from './getPointPointDistance';
import { snapPolyLineToSubPixelGrid } from './snapPolyLineToSubPixelGrid';

export function createLaxExtendLineFromPolygon(lax: PointArray): {
  extendLine: PointArray;
  apicalPointIdx: number;
} {
  // center of closing line
  let basalCenterPoint = {
    x: (lax[0].x + lax[lax.length - 1].x) / 2,
    y: (lax[0].y + lax[lax.length - 1].y) / 2,
  };

  basalCenterPoint = snapPolyLineToSubPixelGrid([basalCenterPoint], false)[0];

  let maxDistance = 0;
  let apicalPoint = lax[0];
  let apicalPointIdx = 0;
  for (let i = 0; i < lax.length; i++) {
    const dist = getPointPointDistance(basalCenterPoint, lax[i]);
    if (dist > maxDistance) {
      maxDistance = dist;
      apicalPoint = lax[i];
      apicalPointIdx = i;
    }
  }

  const extendLine = [basalCenterPoint, apicalPoint];
  return {
    extendLine,
    apicalPointIdx,
  };
}

export function createLaxExtendLine(laxContour: PolygonOpenContour): {
  extendLine: PointArray;
  apicalPointIdx: number;
} {
  const lax = laxContour.getPolygon();
  return createLaxExtendLineFromPolygon(lax);
}
